<script>
import ModalDialog from './ModalDialog.vue'
import ButtonAll from '../Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../../Mixins/global'
import BlockContent from '../Content/BlockContent.vue'

export default {
  components: {
    BlockContent,
    ButtonAll,
    ModalDialog,
  },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],
  data: function () {
    return {
      entities: [],
      contracts: [],
      simulations: [],
      portfolio: [],
      buyouts: [],
      archives: [],
      term: '',
      entityId: '',
      entity: '',
      demands: [],
      score: [],
      isActive: '0',
      isLoading: true,
    }
  },

  methods: {
    getActive: function (value) {
      if (value == this.isActive) {
        return 'btn-toggle'
      }
      return 'btn-primary'
    },

    setActive: function (value) {
      this.isActive = value
    },
    search: function (event) {
      this.getJSON('entities?q=' + this.term, { waitingTextT: 'main.searching' }).then(
        (json) => {
          this.setValue(this, 'entities', json)
          this.contracts.splice(0)
          this.simulations.splice(0)
          this.entity = ''
          if (json.length == 1) {
            this.activity(json[0])
          }
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    activity: function (entity) {
      this.setValue(this, 'entity', entity)
      this.isLoading = true
      var url = 'entities/' + entity.id + '/activity'
      this.getJSON(url, { waitingTextT: 'main.searching' }).then(
        (json) => {
          this.setValue(this, 'entity', json.entity)

          let demands = json.demands
          if (config.conf.demandStatuses) {
            demands = json.demands.filter(
              (demand) => ('-' + config.conf.demandStatuses).indexOf('-' + demand.status) >= 0,
            )
          }

          this.setValue(this, 'demands', demands)
          this.score = this.entity.scoreInfos[config.conf.scoreProvider]
          this.setValue(this, 'contracts', json.contracts)
          this.setValue(this, 'simulations', json.simulations)
          this.isLoading = false
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    openQuotation: function (simulation) {
      if (simulation.status == 'CLIENT_PROPOSAL' || simulation.status == 'CREATED') {
        document.location = '/devis/simulation.php?i=' + simulation.id + '&index=creer'
      } else {
        document.location = '/devis/simulation.php?i=' + simulation.id + '&p=devis&index=simulation'
      }
    },
    openContract: function (contract) {
      if (
        contract.status == 'CLIENT_SIGNED' ||
        contract.status == 'COMPANY_SIGNED' ||
        contract.status == 'CHECKED' ||
        contract.status == 'ORDERED' ||
        contract.status == 'WAITING'
      ) {
        document.location = '/contrats/contract.php?i=' + contract.id + '&p=documents'
      } else if (contract.status == 'DELIVERED' || contract.status == 'COMPLETE') {
        document.location = '/contrats/contract.php?i=' + contract.id + '&p=delivery'
      } else {
        document.location = '/contrats/contract.php?i=' + contract.id + '&p=contract'
      }
    },
    openDemand: function (demand) {
      document.location = '/devis/simulation.php?i=' + demand.decisionOrg.simulation.id + '&p=devis&index=simulation'
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-search"
    class-modal-dialog="modal-xl"
    class-body="mt-3"
    :title="$t('search.title')"
    e2e-modal="search"
  >
    <template #body>
      <div class="row">
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            id="search-input"
            :placeholder="$t('search.input.placeholder')"
            v-model="term"
            e2e-input="search"
          />
        </div>
        <div class="col-md-6">
          <ButtonAll
            margin="no"
            size="small"
            type="validation"
            name="search"
            @click="search"
            label="button.search"
            e2e-button="search"
          />
        </div>
      </div>

      <div v-if="entity != ''">
        <div class="mt-3">
          <h5>{{ $t('main.client') }} {{ entity.name }}</h5>
        </div>

        <div id="search-result" class="row mt-3">
          <div class="col-12">
            <button
              type="button"
              data-toggle="collapse"
              data-target="#collapseInformation"
              aria-expanded="true"
              aria-controls="collapseInformation"
              @click="setActive(0)"
              class="btn"
              :class="getActive(0)"
              e2e-button="info"
            >
              {{ $t('entity.title.info') }}
            </button>
            <button
              type="button"
              data-toggle="collapse"
              data-target="#collapseScore"
              aria-expanded="true"
              aria-controls="collapseScore"
              @click="setActive(1)"
              class="btn"
              :class="getActive(1)"
              e2e-button="score"
            >
              {{ $t('entity.title.score') }}
            </button>
            <button
              v-if="simulations.length > 0"
              type="button"
              data-toggle="collapse"
              data-target="#collapseSimulation"
              aria-expanded="true"
              aria-controls="collapseSimulation"
              @click="setActive(2)"
              class="btn"
              :class="getActive(2)"
              e2e-button="quotations"
            >
              {{ simulations.length }} {{ $t('search.quotations') }}
            </button>
            <button
              v-if="contracts.length > 0"
              type="button"
              data-toggle="collapse"
              data-target="#collapseContracts"
              aria-expanded="true"
              aria-controls="collapseContracts"
              @click="setActive(3)"
              class="btn"
              :class="getActive(3)"
              e2e-button="contracts"
            >
              {{ contracts.length }} {{ $t('search.contracts') }}
            </button>
            <button
              v-if="demands.length > 0"
              type="button"
              data-toggle="collapse"
              data-target="#collapseDemands"
              aria-expanded="true"
              aria-controls="collapseDemands"
              @click="setActive(4)"
              class="btn"
              :class="getActive(4)"
              e2e-button="demands"
            >
              {{ $t('search.demands') }}
            </button>
          </div>

          <div class="col-12" v-if="!isLoading">
            <div
              id="collapseInformation"
              class="collapse show"
              aria-labelledby="headingInformation"
              data-parent="#search-result"
            >
              <div class="card-body">
                <div class="list-group">
                  <div class="card list-group-item list-group-item-action">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.siren') }}</label>
                          <div class="col-lg-8">{{ entity.siren }}</div>
                        </div>
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.createdAt') }}</label>
                          <div class="col-lg-8" v-if="entity.createdAt">
                            {{ setDate(new Date(entity.createdAt), 'date') }}
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.workforce') }}</label>
                          <div class="col-lg-8">{{ entity.workforce }}</div>
                        </div>
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.address') }}</label>
                          <div class="col-lg-8" v-html="entity.address.formattedHtml"></div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.capital') }}</label>
                          <div class="col-lg-8">{{ $n(Number(entity.capital), 'currency_integer') }}</div>
                        </div>
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.legalForm') }}</label>
                          <div class="col-lg-8">{{ entity.legalForm }}</div>
                        </div>
                        <div class="row">
                          <label class="col-lg-4 fs-16">{{ $t('entity.activityDesc') }}</label>
                          <div class="col-lg-8">{{ entity.activityDesc }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="collapseScore" class="collapse hide" aria-labelledby="headingScore" data-parent="#search-result">
              <div class="card-body">
                <div class="list-group">
                  <div class="card list-group-item list-group-item-action">
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="row">
                          <label class="col-lg-6 fs-16">{{ $t('entity.score.score') }}</label>
                          <div class="col-lg-6">{{ score.score }}</div>
                        </div>
                        <div class="row">
                          <label class="col-lg-6 fs-16">{{ $t('entity.score.creditLimit') }}</label>
                          <div class="col-lg-6">{{ $n(Number(score.creditLimit), 'currency_integer') }}</div>
                        </div>
                      </div>
                      <div class="col-lg-8">
                        <div class="row">
                          <label class="col-lg-8 fs-16">{{ $t('entity.judgementFollow') }}</label>
                          <div class="col-lg-4">{{ entity.judgementFollow ? 'Oui' : 'Non' }}</div>
                        </div>
                        <div class="row">
                          <label class="col-lg-8 fs-16">{{ $t('entity.judgementDue') }}</label>
                          <div class="col-lg-4">{{ $n(Number(entity.judgementDue), 'currency_integer') }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-lg-12 fs-16">{{ $t('entity.score.comment') }}</label>
                      <div class="col-lg-12">{{ score.comment }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="simulations.length > 0"
              id="collapseSimulation"
              class="collapse hide"
              aria-labelledby="headingSimulation"
              data-parent="#search-result"
            >
              <div class="card-body">
                <div class="list-group">
                  <div v-for="simulation in simulations">
                    <div
                      class="list-group-item list-group-item-action link"
                      @click="openQuotation(simulation)"
                      v-if="simulation.equipment.productType"
                    >
                      <div class="row">
                        <div class="col-3" :class="'simulation_status simulation_status_' + simulation.status">
                          <strong>{{ simulation.id }}</strong>
                          <br />{{ simulation.finance?.amount }} € <br />{{ simulation.finance?.duration }} Mois
                        </div>
                        <div class="col-3" v-html="$t('simulation.status.' + simulation.status + '.label')"></div>
                        <div class="col-6">
                          <span v-if="simulation.supplier">
                            <strong>{{ simulation.supplier.name }}</strong> - {{ simulation.supplier.siren }}
                          </span>
                          <span v-if="simulation.equipment.equipmentType">
                            <br />{{ simulation.equipment.equipmentType.name }}
                          </span>
                          <span v-if="simulation.equipment.productType">
                            <br />{{ simulation.equipment.productType.name }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="contracts.length > 0"
              id="collapseContracts"
              class="collapse hide"
              aria-labelledby="headingContracts"
              data-parent="#search-result"
            >
              <div class="card-body">
                <div class="list-group">
                  <div
                    class="list-group-item list-group-item-action link"
                    v-for="contract in contracts"
                    @click="openContract(contract)"
                  >
                    <div class="row">
                      <div class="col-3" :class="'contract_status contract_status_' + contract.status">
                        <strong>{{ contract.number }}</strong> <br />{{ contract.finance?.amount }} € <br />{{
                          contract.finance?.duration
                        }}
                        {{ $t('main.month') }}
                      </div>
                      <div class="col-3" v-html="$t('contract.status.' + contract.status + '.label')"></div>
                      <div class="col-6">
                        <span v-if="contract.supplier">
                          <strong>{{ contract.supplier.name }}</strong> - {{ contract.supplier.siren }}
                        </span>
                        <br />{{ contract.equipment.equipmentType.name }}
                        <span v-if="contract.equipment.productType">
                          <br />{{ contract.equipment.productType.name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="demands.length > 0"
              id="collapseDemands"
              class="collapse hide"
              aria-labelledby="headingDemands"
              data-parent="#search-result"
            >
              <div class="card-body">
                <div class="list-group">
                  <div v-for="demand in demands">
                    <div class="list-group-item list-group-item-action link" @click="openDemand(demand)">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="row">
                            <label class="col-lg-6 fs-16">{{ $t('simulation.popin.deal.productName') }}</label>
                            <div class="col-lg-6">{{ demand.productType.name }}</div>
                          </div>
                          <div class="row">
                            <label class="col-lg-6 fs-16">{{ $t('simulation.popin.deal.amountDemand') }}</label>
                            <div class="col-lg-6">{{ $n(Number(demand.finance?.amount), 'integer') }}</div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <label class="col-lg-6 fs-16">{{ $t('simulation.popin.deal.amountAvailable') }}</label>
                            <div class="col-lg-6">
                              {{ $n(Number(demand.outstanding.availableContracts), 'integer') }}
                            </div>
                          </div>
                          <div class="row">
                            <label class="col-lg-6 fs-16">{{ $t('simulation.popin.deal.validity') }}</label>
                            <div class="col-lg-6">{{ setDate(demand.decisionValidity, 'date') }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="portfolio.length > 0">
            <BlockContent inner-bloc-class="border" v-if="portfolio.length > 0">
              <div class="callout callout-warning">
                <div
                  class="card-header"
                  id="search-portfolio"
                  data-toggle="collapse"
                  data-target="#collapsePortfolio"
                  aria-expanded="true"
                  aria-controls="collapsePortfolio"
                >
                  <h5>{{ portfolio.length }} {{ $t('search.portfolio') }}</h5>
                </div>
                <div
                  class="card-header"
                  id="search-portfolio"
                  data-toggle="collapse"
                  data-target="#collapsePortfolio"
                  aria-expanded="true"
                  aria-controls="collapsePortfolio"
                ></div>

                <div
                  id="collapsePortfolio"
                  class="collapse hide"
                  aria-labelledby="headingPortfolio"
                  data-parent="#search-result"
                >
                  <div class="card-body">
                    <div class="list-group">
                      <div
                        class="list-group-item list-group-item-action link"
                        v-for="contract in portfolio"
                        @click="openContract(portfolio)"
                      >
                        <div class="row">
                          <div class="col-3" :class="'contract_status contract_status_' + contract.status">
                            <strong>{{ contract.number }}</strong> <br />{{ contract.finance?.amount }} € <br />{{
                              contract.finance?.duration
                            }}
                            {{ $t('main.month') }}
                          </div>
                          <div class="col-9">
                            <span v-if="contract.supplier">
                              <strong>{{ contract.supplier.name }}</strong> - {{ contract.supplier.siren }}
                            </span>
                            <br />{{ contract.equipment.equipmentType.name }}
                            <span v-if="contract.equipment.productType">
                              <br />{{ contract.equipment.productType.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </BlockContent>
          </div>

          <div class="card" v-if="buyouts.length > 0">
            <BlockContent inner-bloc-class="border" v-if="buyouts.length > 0">
              <div class="callout callout-danger">
                <div
                  class="card-header"
                  id="search-buyouts"
                  data-toggle="collapse"
                  data-target="#collapseBuyouts"
                  aria-expanded="true"
                  aria-controls="collapseBuyouts"
                >
                  <h5>{{ buyouts.length }} {{ $t('search.buyouts') }}</h5>
                </div>
                <div
                  class="card-header"
                  id="search-buyouts"
                  data-toggle="collapse"
                  data-target="#collapseBuyouts"
                  aria-expanded="true"
                  aria-controls="collapseBuyouts"
                ></div>

                <div
                  id="collapseBuyouts"
                  class="collapse hide"
                  aria-labelledby="headingBuyouts"
                  data-parent="#search-result"
                >
                  <div class="card-body">
                    <div class="list-group">
                      <div
                        class="list-group-item list-group-item-action link"
                        v-for="contract in buyouts"
                        @click="openContract(contract)"
                      >
                        <div class="row">
                          <div class="col-3" :class="'contract_status contract_status_' + contract.status">
                            <strong>{{ contract.number }}</strong> <br />{{ contract.finance?.amount }} € <br />{{
                              contract.finance?.duration
                            }}
                            {{ $t('main.month') }}
                          </div>
                          <div class="col-9">
                            <span v-if="contract.supplier">
                              <strong>{{ contract.supplier.name }}</strong> - {{ contract.supplier.siren }}
                            </span>
                            <br />{{ contract.equipment.equipmentType.name }}
                            <span v-if="contract.equipment.productType">
                              <br />{{ contract.equipment.productType.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </BlockContent>
          </div>

          <div class="card" v-if="archives.length > 0">
            <BlockContent inner-bloc-class="border" v-if="archives.length > 0">
              <div class="callout callout-info">
                <div
                  class="card-header"
                  id="search-archive"
                  data-toggle="collapse"
                  data-target="#collapseArchives"
                  aria-expanded="true"
                  aria-controls="collapseArchives"
                >
                  <h5>{{ archives.length }} {{ $t('search.archives') }}</h5>
                </div>
                <div
                  class="card-header"
                  id="search-archive"
                  data-toggle="collapse"
                  data-target="#collapseArchives"
                  aria-expanded="true"
                  aria-controls="collapseArchives"
                ></div>

                <div
                  id="collapseArchives"
                  class="collapse hide"
                  aria-labelledby="headingArchives"
                  data-parent="#search-result"
                >
                  <div class="card-body">
                    <div class="list-group">
                      <div
                        class="list-group-item list-group-item-action link"
                        v-for="contract in archives"
                        @click="openContract(contract)"
                      >
                        <div class="row">
                          <div class="col-3" :class="'contract_status contract_status_' + contract.status">
                            <strong>{{ contract.number }}</strong> <br />{{ contract.finance?.amount }} € <br />{{
                              contract.finance?.duration
                            }}
                            {{ $t('main.month') }}
                          </div>
                          <div class="col-9">
                            <span v-if="contract.supplier">
                              <strong>{{ contract.supplier.name }}</strong> - {{ contract.supplier.siren }}
                            </span>
                            <br />{{ contract.equipment.equipmentType.name }}
                            <span v-if="contract.equipment.productType">
                              <br />{{ contract.equipment.productType.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </BlockContent>
          </div>
        </div>
      </div>

      <div class="list-group mt-3" v-else>
        <div v-for="entity in entities">
          <div class="list-group-item list-group-item-action link" @click="activity(entity)">
            <div class="row">
              <div class="col-4">{{ entity.name }}</div>
              <div class="col-4">{{ entity.siren }}</div>
              <div class="col-4">{{ entity.address.postalCode }} - {{ entity.address.city }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      &nbsp;<button type="button" class="btn btn-primary" data-dismiss="modal" e2e-button="close">
        {{ $t('main.dismiss') }}
      </button>
    </template>
  </ModalDialog>
</template>
